// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700&family=Gothic+A1&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.one_wrapper {
  width: 100%;
  /* height: 500px; */
  padding: 0 62px;
}

.one_heading_div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.one_heading {
  text-transform: uppercase;
  font-size: 160px;
  font-weight: 1000;
  letter-spacing: 10px;
  background-image: linear-gradient(90deg, #fff 50%, #151515 50%),
    linear-gradient(
      45deg,
      #151615,
      #151615,
      #151615,
      #151615,
      #151615,
      #504f4f,
      #525050,
      #2d2b2b
    );
  background-size: 200% 100%, 400% 400%;
  background-position: 100% 0, 0 0;
  background-clip: text, padding-box;
  -webkit-background-clip: text, padding-box;
  -webkit-text-fill-color: transparent;
  -webkit-text-stroke: 2px white;
  animation: one-animation 4s ease-in-out infinite;
  border-bottom: 6px solid #206d23;
  padding: 0 20px;
  margin-bottom: 48px;
}
@keyframes one-animation {
  0% {
    background-position: 100% 0, 0 0;
  }
  50% {
    background-position: 0 0, 0 0;
  }
  100% {
    background-position: 100% 0, 0 0;
  }
}

.one_para_div > p {
  margin-bottom: 15px;
  color: #cecece;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Open Sans";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 38.4px; /* 160% */
}

@media screen and (max-width: 1200px) {
  .one_wrapper {
    width: 100%;
    padding: 0 62px;
  }

  .one_heading_div {
    width: 100%;
  }

  .one_heading {
    font-size: 150px;
    font-weight: 1000;
    letter-spacing: 10px;
    border-bottom: 4px solid #206d23;
    padding: 0 20px;
    margin-bottom: 40px;
  }

  .one_para_div > p {
    font-size: 22px;
    line-height: 28px;
    margin-bottom: 10px;
  }
}

@media screen and (max-width: 1024px) {
  .one_wrapper {
    width: 100%;
    padding: 0 20px;
  }

  .one_heading_div {
    width: 100%;
    margin: 0;
  }

  .one_heading {
    font-size: 140px;
    font-weight: 1000;
    letter-spacing: 10px;
    border-bottom: 4px solid #206d23;
    padding: 0 16px;
    margin-bottom: 30px;
  }

  .one_para_div > p {
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 10px;
  }
}

@media screen and (max-width: 800px) {
  .one_wrapper {
    width: 100%;
    padding: 0 20px;
  }

  .one_heading_div {
    width: 100%;
    margin: 50px 0 0px 0;
  }

  .one_heading {
    font-size: 110px;
    font-weight: 1000;
    letter-spacing: 5px;
    border-bottom: 4px solid #206d23;
    padding: 0 16px;
    margin-bottom: 30px;
  }

  .one_para_div > p {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 10px;
  }
}

@media screen and (max-width: 600px) {
  .one_wrapper {
    width: 100%;
    padding: 0 20px;
  }

  .one_heading_div {
    width: 100%;
    margin: 50px 0 0px 0;
  }

  .one_heading {
    font-size: 80px;
    font-weight: 1000;
    letter-spacing: 5px;
    border-bottom: 4px solid #206d23;
    padding: 0 16px;
    margin-bottom: 20px;
  }

  .one_para_div > p {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 10px;
  }
}

@media screen and (max-width: 450px) {
  .one_wrapper {
    width: 100%;
    padding: 0 16px;
  }

  .one_heading_div {
    width: 100%;
    margin: 40px 0 10px 0;
  }

  .one_heading {
    font-size: 60px;
    font-weight: 1000;
    letter-spacing: 5px;
    border-bottom: 4px solid #206d23;
    padding: 0 16px;
    margin-bottom: 10px;
  }

  .one_para_div > p {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/homePage/one/one.css"],"names":[],"mappings":"AAIA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB;;;;;;;;;;;KAWG;EACH,qCAAqC;EACrC,gCAAgC;EAChC,kCAAkC;EAClC,0CAA0C;EAC1C,oCAAoC;EACpC,8BAA8B;EAC9B,gDAAgD;EAChD,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,6CAA6C;EAC7C,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,SAAS;AAChC;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;IAChC,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;IAChC,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700&family=Gothic+A1&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap\");\n\n.one_wrapper {\n  width: 100%;\n  /* height: 500px; */\n  padding: 0 62px;\n}\n\n.one_heading_div {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n}\n\n.one_heading {\n  text-transform: uppercase;\n  font-size: 160px;\n  font-weight: 1000;\n  letter-spacing: 10px;\n  background-image: linear-gradient(90deg, #fff 50%, #151515 50%),\n    linear-gradient(\n      45deg,\n      #151615,\n      #151615,\n      #151615,\n      #151615,\n      #151615,\n      #504f4f,\n      #525050,\n      #2d2b2b\n    );\n  background-size: 200% 100%, 400% 400%;\n  background-position: 100% 0, 0 0;\n  background-clip: text, padding-box;\n  -webkit-background-clip: text, padding-box;\n  -webkit-text-fill-color: transparent;\n  -webkit-text-stroke: 2px white;\n  animation: one-animation 4s ease-in-out infinite;\n  border-bottom: 6px solid #206d23;\n  padding: 0 20px;\n  margin-bottom: 48px;\n}\n@keyframes one-animation {\n  0% {\n    background-position: 100% 0, 0 0;\n  }\n  50% {\n    background-position: 0 0, 0 0;\n  }\n  100% {\n    background-position: 100% 0, 0 0;\n  }\n}\n\n.one_para_div > p {\n  margin-bottom: 15px;\n  color: #cecece;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-family: \"Open Sans\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 38.4px; /* 160% */\n}\n\n@media screen and (max-width: 1200px) {\n  .one_wrapper {\n    width: 100%;\n    padding: 0 62px;\n  }\n\n  .one_heading_div {\n    width: 100%;\n  }\n\n  .one_heading {\n    font-size: 150px;\n    font-weight: 1000;\n    letter-spacing: 10px;\n    border-bottom: 4px solid #206d23;\n    padding: 0 20px;\n    margin-bottom: 40px;\n  }\n\n  .one_para_div > p {\n    font-size: 22px;\n    line-height: 28px;\n    margin-bottom: 10px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .one_wrapper {\n    width: 100%;\n    padding: 0 20px;\n  }\n\n  .one_heading_div {\n    width: 100%;\n    margin: 0;\n  }\n\n  .one_heading {\n    font-size: 140px;\n    font-weight: 1000;\n    letter-spacing: 10px;\n    border-bottom: 4px solid #206d23;\n    padding: 0 16px;\n    margin-bottom: 30px;\n  }\n\n  .one_para_div > p {\n    font-size: 20px;\n    line-height: 26px;\n    margin-bottom: 10px;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .one_wrapper {\n    width: 100%;\n    padding: 0 20px;\n  }\n\n  .one_heading_div {\n    width: 100%;\n    margin: 50px 0 0px 0;\n  }\n\n  .one_heading {\n    font-size: 110px;\n    font-weight: 1000;\n    letter-spacing: 5px;\n    border-bottom: 4px solid #206d23;\n    padding: 0 16px;\n    margin-bottom: 30px;\n  }\n\n  .one_para_div > p {\n    font-size: 18px;\n    line-height: 24px;\n    margin-bottom: 10px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .one_wrapper {\n    width: 100%;\n    padding: 0 20px;\n  }\n\n  .one_heading_div {\n    width: 100%;\n    margin: 50px 0 0px 0;\n  }\n\n  .one_heading {\n    font-size: 80px;\n    font-weight: 1000;\n    letter-spacing: 5px;\n    border-bottom: 4px solid #206d23;\n    padding: 0 16px;\n    margin-bottom: 20px;\n  }\n\n  .one_para_div > p {\n    font-size: 18px;\n    line-height: 24px;\n    margin-bottom: 10px;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .one_wrapper {\n    width: 100%;\n    padding: 0 16px;\n  }\n\n  .one_heading_div {\n    width: 100%;\n    margin: 40px 0 10px 0;\n  }\n\n  .one_heading {\n    font-size: 60px;\n    font-weight: 1000;\n    letter-spacing: 5px;\n    border-bottom: 4px solid #206d23;\n    padding: 0 16px;\n    margin-bottom: 10px;\n  }\n\n  .one_para_div > p {\n    font-size: 16px;\n    line-height: 22px;\n    margin-bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
